function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M4 10.44C4 6.892 6.891 4 10.44 4c3.55 0 6.441 2.891 6.441 6.44a6.407 6.407 0 01-1.444 4.056l4.358 4.357a.666.666 0 11-.942.942l-4.358-4.357a6.414 6.414 0 01-4.054 1.443A6.45 6.45 0 014 10.441zm11.549 0a5.098 5.098 0 00-5.108-5.107 5.097 5.097 0 00-5.108 5.108 5.098 5.098 0 005.108 5.108 5.086 5.086 0 003.54-1.426.683.683 0 01.142-.142 5.086 5.086 0 001.426-3.54z",
  clipRule: "evenodd"
});

function SvgSearchBlackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgSearchBlackinline;